import QuestionDetails from "../components/QuestionsDetails";

const DEFAULT_QUESTIONS = [
  "First Name",
  "Last Name",
  "Email",
  "PGA Number (Optional)",
  "Phone",
  "City, State",
  "Current or most recent position",
  "Current or most recent employer",
  "How did you learn about this job opportunity",
  "Document Upload"
];

export function ApplicationFormStep({ form }: { form: any }) {
  return (
    <div className="space-y-6">
      <div className="text-headline-small">Customize the job application form.</div>
      <div className="mt-8 text-body-medium">
        <div className="text-title-medium mb-2">Job Application Form Questions</div>
        <p>
          This job has a custom application form. Some questions are always present and required by default. You can
          optionally add additional questions as needed below.
        </p>
        <p className="mt-4 mb-2">Default/Required Questions:</p>
        <ul className="list-disc pl-4 space-y-1 mb-6">
          {DEFAULT_QUESTIONS.map((question) => (
            <li key={question}>{question}</li>
          ))}
        </ul>
        <hr className="my-3 w-full  border-sys-brand-outline-variant h-[1px] border-t" />

        <div className="text-title-medium my-6">Additional Custom Questions (Optional)</div>
        <QuestionDetails form={form} />
      </div>
    </div>
  );
}
